import { h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
// import OnSiteSearchServiceLinks from "../../templates/cwc-onsite-search-servicelinks";

const OrderStatusOnSiteSearchModuleTemplate = (context) => [
  <module name={'orderstatus'}>
    <orderstatus-image>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 997.3 850.3">
        <defs>
          <clipPath id="a">
            <path
              fill="none"
              stroke-width="0"
              d="M561.81 563.03h21.43v13.67h-21.43z"
              transform="rotate(-10 572.55 569.878)"
            />
          </clipPath>
        </defs>
        <path
          fill="#f7f1ea"
          d="M894.7 372.8h.1c-13.45-117.78-62.86-178.23-184.2-188.1-78.21-22.04-135.2-90.78-216-106.4-62.03-13.68-123.14 12.69-174.9 45.2-96.56 56.65-172.17 161.95-155.45 276.99-.05.12-3.29 7.59-3.35 7.71l.06.32C129.27 481.9 97.55 573.5 146.3 646.3c19.66 29.67 48.3 52.64 78.7 70.6 99.55 58.06 219.69 71.95 333 62.7 63.8-6.63 129.95-23.72 180.7-64.6 30.43-27.97 48.83-66.35 60.9-105.4 64.25-59.08 106.92-148.31 95.1-236.8Z"
        />
        <path
          fill="#e2e7ea"
          d="M146.3 646.1c99.77 146.99 427.25 175.71 570.9 84.4 43.73-25.62 67.71-74.02 82.4-120.9l2.65.6c-178.5-48.7-468.55-64.1-667.45 15.4a160.22 160.22 0 0 0 11.5 20.5Z"
        />
        <path fill="#a9bfc9" d="M440.9 516.9h19.4v117.7h-19.4V516.9Z" />
        <path
          fill="#8da2af"
          d="M469.35 637.6c1.71 0 3.06-1.5 2.81-3.19-1.55-10.47-10.58-18.5-21.48-18.49-10.89 0-19.9 8.03-21.45 18.49-.25 1.69 1.11 3.19 2.81 3.19h37.3Z"
        />
        <path fill="#a9bfc9" d="M756.1 516.9h19.4v117.7h-19.4z" />
        <path
          fill="#8da2af"
          d="M784.55 637.6c1.71 0 3.06-1.5 2.81-3.19-1.54-10.5-10.59-18.56-21.52-18.56s-19.97 8.06-21.52 18.56c-.25 1.69 1.11 3.19 2.81 3.19h37.41ZM368.78 466.8h561.84c.32 0 .58.22.58.5v52.01c0 .27-.26.5-.58.5 0 0-185.83 5.26-248.46 0-53.81-4.52-160.93-2.9-216 0-24.31 1.28-97.38 0-97.38 0-.32 0-.58-.22-.58-.5V467.3c0-.27.26-.5.58-.5Z"
        />
        <path
          fill="#d5d0ca"
          d="M422.9 487.2h-18.8c-3.31 0-6 2.69-6 6s2.69 6 6 6h18.8c3.31 0 6-2.69 6-6s-2.69-6-6-6ZM475.61 487.2h-18.9c-3.31 0-6 2.69-6 6s2.69 6 6 6h18.9c3.31 0 6-2.69 6-6s-2.69-6-6-6ZM528.21 487.2h-18.8c-3.31 0-6 2.69-6 6s2.69 6 6 6h18.8c3.31 0 6-2.69 6-6s-2.69-6-6-6ZM580.87 487.2h-18.8c-3.31 0-6 2.69-6 6s2.69 6 6 6h18.8c3.31 0 6-2.69 6-6s-2.69-6-6-6ZM633.52 487.2h-18.8c-3.31 0-6 2.69-6 6s2.69 6 6 6h18.8c3.31 0 6-2.69 6-6s-2.69-6-6-6ZM686.23 487.2h-18.9c-3.31 0-6 2.69-6 6s2.69 6 6 6h18.9c3.31 0 6-2.69 6-6s-2.69-6-6-6ZM738.78 487.2h-18.7c-3.31 0-6 2.69-6 6s2.69 6 6 6h18.7c3.31 0 6-2.69 6-6s-2.69-6-6-6ZM791.49 487.2h-18.8c-3.31 0-6 2.69-6 6s2.69 6 6 6h18.8c3.31 0 6-2.69 6-6s-2.69-6-6-6ZM844.14 487.2h-18.8c-3.31 0-6 2.69-6 6s2.69 6 6 6h18.8c3.31 0 6-2.69 6-6s-2.69-6-6-6ZM896.8 487.2H878c-3.31 0-6 2.69-6 6s2.69 6 6 6h18.8c3.31 0 6-2.69 6-6s-2.69-6-6-6Z"
        />
        <rect width="110.8" height="77.4" x="350.4" y="389.4" fill="#bfa78c" rx="3" ry="3" />
        <path
          fill="#a78559"
          d="M414 410.88c0 .49-.64.69-.91.28l-2.2-3.21c-.39-.57-1.21-.58-1.63-.04l-2.95 3.97c-.2.27-.61.27-.81 0l-2.82-3.98c-.39-.55-1.2-.56-1.61-.03l-2.68 3.5c-.29.38-.9.17-.9-.3V389.4h16.5v21.48Z"
        />
        <rect width="32.9" height="20.6" x="418.1" y="438.3" fill="#a78559" rx="2.4" ry="2.4" />
        <rect width="110.8" height="77.4" x="726.2" y="389.4" fill="#bfa78c" rx="3" ry="3" />
        <path
          fill="#a78559"
          d="M789.8 410.88c0 .49-.64.69-.91.28l-2.2-3.21c-.39-.57-1.21-.58-1.63-.04l-2.95 3.97c-.2.27-.61.27-.81 0l-2.82-3.98c-.39-.55-1.2-.56-1.61-.03l-2.68 3.5c-.29.38-.9.17-.9-.3V389.4h16.5v21.48Z"
        />
        <rect width="32.9" height="20.6" x="793.9" y="438.3" fill="#a78559" rx="2.4" ry="2.4" />
        <path fill="#b7ada5" d="M323.5 626.8H125s-8.7-54.4 0-108.9c8-49 192.4-49.2 198.5 0 7.8 63.2 0 109 0 109v-.1Z" />
        <path
          fill="#585e5c"
          d="M313.7 530.6c-44.7-2.1-134.3-3.8-179 0-2.9.2-11.6 1.7-11.6 1.7s1.1-9.6 2-14.4c7.8-49 192.3-49.2 198.4 0l1.4 13.7s-8.3-1-11.2-1Z"
          opacity=".2"
        />
        <path
          fill="#585e5c"
          d="M376.9 519.8h-52.8V350.9l50.88 23.08a8.003 8.003 0 0 1 3.92 6.88V517.8c0 1.1-.9 2-2 2Z"
        />
        <path
          fill="#bf0004"
          d="M119.72 519.8c-4.38 0-8.05-3.32-8.46-7.69-2.22-23.17-8.65-92.25-8.65-116.91 0-28.18 2-112.7 2-112.7l2-14.6h234.4l2 14.3s3 85.65 3 114.2c0 24.42-7.05 92.86-9.48 115.8a8.506 8.506 0 0 1-8.46 7.6H119.72Z"
        />
        <path
          fill="#f6f0e9"
          d="M314.99 506.69H133.63a8.5 8.5 0 0 1-8.5-8.5s-8-70.08-8-102.09c0-30.13 3-102.84 3-102.84a8.5 8.5 0 0 1 8.5-8.5h191.36a8.5 8.5 0 0 1 8.5 8.5s3 70.93 3 102.84c0 37.36-8 102.09-8 102.09a8.5 8.5 0 0 1-8.5 8.5Z"
        />
        <path
          fill="#bf0004"
          d="M320.3 444.36c8.62 1.64 7.76 10.24 7.76 10.24l7.14-24.3-3.67-30.09s.16 7.89-7.5 15.09c-4.88 4.59-11.16 3.69-11.16 7.84l-1.85 15.47c0 4.8 1.31 4.22 9.29 5.74ZM128.46 444.36c-8.62 1.64-7.76 10.24-7.76 10.24l-7.14-24.3 3.67-30.09s-.16 7.89 7.5 15.09c4.88 4.59 11.16 3.69 11.16 7.84l1.85 15.47c0 4.8-1.31 4.22-9.29 5.74Z"
        />
        <rect width="144" height="108" x="174.4" y="297" fill="#585e5c" rx="8" ry="8" />
        <rect width="127.4" height="91.4" x="182.7" y="304.8" fill="#fff" rx="4" ry="4" />
        <path
          fill="#585e5c"
          d="M305.02 604.28h-62.86c-.6 0-1.08.79-1.08 1.76s.48 1.76 1.08 1.76h62.86c.6 0 1.08-.79 1.08-1.76s-.48-1.76-1.08-1.76ZM305.02 591.54h-62.86c-.6 0-1.08.79-1.08 1.76s.48 1.76 1.08 1.76h62.86c.6 0 1.08-.79 1.08-1.76s-.48-1.76-1.08-1.76ZM242.16 582.33h62.86c.6 0 1.08-.79 1.08-1.76s-.48-1.76-1.08-1.76h-62.86c-.6 0-1.08.79-1.08 1.76s.48 1.76 1.08 1.76Z"
        />
        <path
          fill="#585e5c"
          d="M314.43 637.6H134.08c-4.1 0-7.62-2.92-8.36-6.96l-.71-3.84h198.5l-.71 3.84a8.51 8.51 0 0 1-8.36 6.96Z"
          opacity=".5"
        />
        <rect width="22.2" height="7.9" x="235.25" y="471.1" fill="#bfa78c" rx="2.83" ry="2.83" />
        <rect width="22.2" height="7.9" x="261.65" y="471.1" fill="#bfa78c" rx="2.83" ry="2.83" />
        <rect width="22.2" height="7.9" x="288.15" y="471.1" fill="#bfa78c" rx="2.83" ry="2.83" />
        <rect width="22.2" height="7.9" x="235.25" y="458.6" fill="#bfa78c" rx="2.83" ry="2.83" />
        <rect width="22.2" height="7.9" x="261.65" y="458.6" fill="#bfa78c" rx="2.83" ry="2.83" />
        <rect width="22.2" height="7.9" x="288.15" y="458.6" fill="#bfa78c" rx="2.83" ry="2.83" />
        <rect width="22.2" height="7.9" x="235.25" y="483.5" fill="#bfa78c" rx="2.83" ry="2.83" />
        <rect width="22.2" height="7.9" x="261.65" y="483.5" fill="#bfa78c" rx="2.83" ry="2.83" />
        <rect width="22.2" height="7.9" x="288.15" y="483.5" fill="#bfa78c" rx="2.83" ry="2.83" />
        <path
          fill="#585e5c"
          d="M199.66 459.1h14.61c.96 0 1.73.63 1.73 1.4v28.3c0 .77-.78 1.4-1.73 1.4h-14.61c-.96 0-1.73-.63-1.73-1.4v-28.3c0-.77.78-1.4 1.73-1.4Z"
        />
        <path
          fill="#d6be9e"
          d="M201.39 461.5h11.14c.98 0 1.78.95 1.78 2.13v3.1c0 1.17-.8 2.13-1.78 2.13h-11.14c-.98 0-1.78-.95-1.78-2.13v-3.1c0-1.17.8-2.13 1.78-2.13Z"
        />
        <path
          fill="#bfa78c"
          d="M201.39 471.37h11.14c.98 0 1.78.95 1.78 2.13v3.1c0 1.17-.8 2.13-1.78 2.13h-11.14c-.98 0-1.78-.95-1.78-2.13v-3.1c0-1.17.8-2.13 1.78-2.13ZM201.39 481.25h11.14c.98 0 1.78.95 1.78 2.13v3.1c0 1.17-.8 2.13-1.78 2.13h-11.14c-.98 0-1.78-.95-1.78-2.13v-3.1c0-1.17.8-2.13 1.78-2.13Z"
        />
        <path
          fill="#585e5c"
          d="M173.62 459.1h14.61c.96 0 1.73.63 1.73 1.4v28.3c0 .77-.78 1.4-1.73 1.4h-14.61c-.96 0-1.73-.63-1.73-1.4v-28.3c0-.77.78-1.4 1.73-1.4Z"
        />
        <path
          fill="#d6be9e"
          d="M175.35 461.5h11.14c.98 0 1.78.95 1.78 2.13v3.1c0 1.17-.8 2.13-1.78 2.13h-11.14c-.98 0-1.78-.95-1.78-2.13v-3.1c0-1.17.8-2.13 1.78-2.13ZM175.35 471.37h11.14c.98 0 1.78.95 1.78 2.13v3.1c0 1.17-.8 2.13-1.78 2.13h-11.14c-.98 0-1.78-.95-1.78-2.13v-3.1c0-1.17.8-2.13 1.78-2.13Z"
        />
        <path
          fill="#bfa78c"
          d="M175.35 481.25h11.14c.98 0 1.78.95 1.78 2.13v3.1c0 1.17-.8 2.13-1.78 2.13h-11.14c-.98 0-1.78-.95-1.78-2.13v-3.1c0-1.17.8-2.13 1.78-2.13Z"
        />
        <path
          fill="#585e5c"
          d="M147.58 459.1h14.61c.96 0 1.73.63 1.73 1.4v28.3c0 .77-.78 1.4-1.73 1.4h-14.61c-.96 0-1.73-.63-1.73-1.4v-28.3c0-.77.78-1.4 1.73-1.4Z"
        />
        <path
          fill="#d6be9e"
          d="M149.32 461.5h11.14c.98 0 1.78.95 1.78 2.13v3.1c0 1.17-.8 2.13-1.78 2.13h-11.14c-.98 0-1.78-.95-1.78-2.13v-3.1c0-1.17.8-2.13 1.78-2.13Z"
        />
        <path
          fill="#bfa78c"
          d="M149.32 471.37h11.14c.98 0 1.78.95 1.78 2.13v3.1c0 1.17-.8 2.13-1.78 2.13h-11.14c-.98 0-1.78-.95-1.78-2.13v-3.1c0-1.17.8-2.13 1.78-2.13ZM149.32 481.25h11.14c.98 0 1.78.95 1.78 2.13v3.1c0 1.17-.8 2.13-1.78 2.13h-11.14c-.98 0-1.78-.95-1.78-2.13v-3.1c0-1.17.8-2.13 1.78-2.13Z"
        />
        <path
          fill="#d6be9e"
          d="M238.08 471.1h3.53c-2.18 1.87-2.26 6 0 7.9h-3.53c-1.57 0-2.83-1.27-2.83-2.83v-2.23c0-1.57 1.27-2.83 2.83-2.83ZM238.08 458.6h3.53c-2.18 1.87-2.26 6 0 7.9h-3.53c-1.57 0-2.83-1.27-2.83-2.83v-2.23c0-1.57 1.27-2.83 2.83-2.83ZM238.08 483.5h3.53c-2.18 1.87-2.26 6 0 7.9h-3.53c-1.57 0-2.83-1.27-2.83-2.83v-2.23c0-1.57 1.27-2.83 2.83-2.83ZM264.48 471.1h3.53c-2.18 1.87-2.26 6 0 7.9h-3.53c-1.57 0-2.83-1.27-2.83-2.83v-2.23c0-1.57 1.27-2.83 2.83-2.83ZM264.48 458.6h3.53c-2.18 1.87-2.26 6 0 7.9h-3.53c-1.57 0-2.83-1.27-2.83-2.83v-2.23c0-1.57 1.27-2.83 2.83-2.83ZM264.48 483.5h3.53c-2.18 1.87-2.26 6 0 7.9h-3.53c-1.57 0-2.83-1.27-2.83-2.83v-2.23c0-1.57 1.27-2.83 2.83-2.83ZM290.98 471.1h3.53c-2.18 1.87-2.26 6 0 7.9h-3.53c-1.57 0-2.83-1.27-2.83-2.83v-2.23c0-1.57 1.27-2.83 2.83-2.83ZM290.98 458.6h3.53c-2.18 1.87-2.26 6 0 7.9h-3.53c-1.57 0-2.83-1.27-2.83-2.83v-2.23c0-1.57 1.27-2.83 2.83-2.83ZM290.98 483.5h3.53c-2.18 1.87-2.26 6 0 7.9h-3.53c-1.57 0-2.83-1.27-2.83-2.83v-2.23c0-1.57 1.27-2.83 2.83-2.83Z"
        />
        <path
          fill="#9c0000"
          d="m343 282.3-1.6-20.6a3.407 3.407 0 0 0-2.8-3c-64.1-12.6-166.3-12.6-230.4 0a3.4 3.4 0 0 0-2.8 3.2l-.8 20.6c19-3.5 219.5-3.6 238.4-.2Z"
        />
        <path
          fill="#bf0004"
          d="m343 282.3-1.6-20.6a3.407 3.407 0 0 0-2.8-3c-64.1-12.6-175.83 19.9-233.87 20.61l-.13 3.19c19-3.5 219.5-3.6 238.4-.2Z"
        />
        <circle cx="256.7" cy="417.4" r="5.7" fill="#bfa78c" />
        <circle cx="274.9" cy="417.4" r="5.7" fill="#bfa78c" />
        <circle cx="293.2" cy="417.4" r="5.7" fill="#bfa78c" />
        <path
          fill="#e2e7ea"
          d="M186.7 304.8h119.4c2.21 0 4 1.79 4 4 0 0-15.98 28.95-52.6 54.48-20.12 14.03-70.8 32.92-70.8 32.92-2.21 0-4-1.79-4-4v-83.4c0-2.21 1.79-4 4-4Z"
        />
        <path
          fill="#bfa78c"
          d="M621.75 368.75s.67 20.29 0 27c-.8 8.06.97 30.22.3 41.74-.41 7.08-.3 26.57-.3 26.57a2.78 2.78 0 0 1-2.78 2.78h-74.44c-1.54 0-2.78-1.26-2.78-2.79 0 0 .17-21.46 0-28.61-.16-6.79.8-43.98 0-50.28-.51-4.07 0-16.43 0-16.43 0-1.22.79-2.3 1.96-2.66.27-.09.55-.13.83-.13h74.44c.28 0 .56.05.83.14.44.14.83.38 1.15.7.51.52.8 1.22.8 1.96"
        />
        <path
          fill="#8a7156"
          d="M560.72 384.53s12.59 8.12 27.94 7.06c5.79-.4 11.4-2.34 15.72-4.81 9.6-5.5 15.36-15.27 15.56-17.67.27-3.14-59.21 15.42-59.21 15.42Z"
        />
        <path
          fill="#9d846a"
          d="M620.95 366.8c-2.55 7.06-9.07 13.28-17.4 17.35-.99.49-2.01.94-3.05 1.36s-2.1.81-3.18 1.17c-.54.17-1.08.35-1.63.51-.82.24-1.66.46-2.5.66s-1.68.38-2.54.54c-.57.1-1.14.19-1.71.29-1.44.21-2.89.36-4.35.44-.58.03-1.17.06-1.75.07h-.99a48.597 48.597 0 0 1-9.56-.96c-.28-.06-.56-.11-.85-.18-.56-.12-1.12-.25-1.67-.39-.29-.07-.57-.15-.85-.23-.56-.15-1.1-.31-1.64-.47h-.01c-.27-.08-.54-.17-.82-.26a46.887 46.887 0 0 1-14.49-7.65c-.31-.24-.62-.49-.92-.75-1.06-.89-2.06-1.84-3-2.85-.26-.27-.51-.56-.76-.83-.4-.46-.78-.93-1.14-1.39-.29-.38-.57-.76-.84-1.15-.4-.59-.78-1.18-1.13-1.78-.65-1.11-1.2-2.28-1.65-3.49.32-.33.72-.57 1.16-.71h76.1c.44.15.83.39 1.16.71"
        />
        <path
          fill="#9d846a"
          d="M619.79 366.09h-.8c-.86 2.31-2.1 4.46-3.66 6.37a33.95 33.95 0 0 1-8.63 7.53c-3.61 2.26-7.52 4-11.61 5.18a47.53 47.53 0 0 1-13.14 1.93h-.1a46.98 46.98 0 0 1-13.17-1.91 47.013 47.013 0 0 1-11.71-5.19 34.78 34.78 0 0 1-8.76-7.55 22.834 22.834 0 0 1-3.73-6.38h-.8c-.44.14-.84.38-1.16.71.45 1.21 1 2.37 1.65 3.49.35.6 3.61 4.88 3.87 5.16 2.21 2.35 4.68 4.44 7.34 6.26 3.46 2.13 7.18 3.81 11.07 4.99.27.09.54.17.82.26h.01c.54.17 1.09.33 1.64.47.28.08 1.95.5 2.52.62.29.07 2.53.49 3.37.62 2.33.35 7.15.53 7.15.53 2.33-.04 4.66-.22 6.98-.53 3.17-.61 10.52-2.73 11.56-3.16 1.04-.42 2.06-.88 3.05-1.36 4.06-1.92 7.73-4.59 10.79-7.87 2.62-2.75 5.44-6.26 6.6-9.48-.32-.32-.72-.56-1.15-.7"
        />
        <path
          fill="#ae231c"
          d="M581.31 438.08s18.11-11.05 11.46-19.47c-4.58-5.8-11.21 4.18-11.21 4.18s-1.41-6.83-7.43-6.4c-6.02.43-4.32 14.41 7.17 21.69"
        />
        <path
          fill="#e7c19f"
          d="M654.59 762.87c-13.29-17.17-24.15-32.34-29.3-37.33-5.5 1.37-16.94 1.41-28.52 2.54-9.38.92-30.59-2.44-41.18-6.65-15.81-6.28-21.75-16.78-34.53-31.47l98.26-31.64c.1-2.87-.24-37.72-3.39-42.45 0 0 21.41-3.79 28.19-4.03 3.3-.12 4.98-.37 13.18 10.91 3.49 7.26 8.49 14.01 10.92 28.34 1.18 6.99 4.98 24.55 4.98 24.55-.06 1.04.24 2.06.86 2.9 6.54 8.5 28.6 26.68 53.13 47.46 2.63 2.23-70.24 39.9-72.58 36.87Z"
        />
        <path
          fill="#e7c19f"
          d="M625.46 647.37c2.64-.64-4.99-23.98-1.48-28.05 0 0-3.95-16.67-4.42-23.93-.86-13.21-4.37-24.64-6.07-36.22a14.27 14.27 0 0 1 1.76-12.32 4.805 4.805 0 0 1 6.66-1.55c.7.45 1.26 1.07 1.64 1.81 1.29 2.74.34 8.09 2.47 10.25 3.42 3.63 3.57 8.3 6.31 12.47 1.41 2.19 2.06 7.68 2.85 10.16l6.78 21.74c2.96 6.35 4.86 10.21 8 12.56 5.49 4.1 7.92 9.71 9.9 13.4 1.76 9.57-5.96 8.28-5.96 16.43-4.47 13.47-28.43 3.24-28.43 3.24Z"
        />
        <path
          d="M621.34 604.69s9.93 32.37 11.24 38.69c1.55 7.48 1.73 13.19 3.58 28.13.48 3.85-1.86 15.49-1.86 15.49l-12.97-82.31ZM634.52 688.65s1.51 13.36-9.06 18.7c-6.66 3.36-24.04 4.66-32.14 6.52-5.84 1.34-22.88 2.07-29.13 3-7.85 1.17-20.1-.42-20.1-.42l90.42-27.8Z"
          opacity=".08"
        />
        <path
          fill="#e7c19f"
          d="M499.81 658.48c-.15-.76-3.76-22.96-3.93-24.23-.49-3.9-2.22-17.19-4.65-22.49 3.79.1 3.02-29.2-4.75-33.06-1.83-.91-4.17-1.63-6.64-.79-2.04.7-3.97 4.04-4.7 5.66s-.74 3.23-.61 4.76c.23 2.88 4.33 17.34 10.82 21.25.45.27.88.51 1.29.72-.48.22-.94.49-1.34.83-6.21 5.4-4.07 17.91-.06 24.97-.07.1-1.57 4.31-1.36 8.45.16 3.2 1.66 9.45 3.93 11.4 1.18 1.01 3.18 3.75 3.24 3.76-.21.35-.36 6.01-.22 8.95.08 1.57.27 3.15.87 4.56.72 1.7 5.54 4.74 7.3 4.63 2.05-.13 3.95-1.62 3.92-3.79-.07-5.9-1.98-9.9-3.1-15.58Z"
        />
        <path
          fill="#fff"
          d="m575.8 459.4-89.3 16c-8.82 1.57-14.71 9.97-13.2 18.8l37.3 209.3c1.62 8.86 10.11 14.72 18.96 13.11h.04l89.2-16c8.86-1.53 14.81-9.94 13.3-18.8l-37.5-209.3c-1.67-8.83-10.17-14.64-19-13l.2-.1Z"
        />
        <circle cx="552.2" cy="579.08" r="51.52" fill="#f7f1ea" />
        <path
          fill="#f6f3f1"
          d="M557.36 601.76c-20.67 3.65-37.19 7.96-36.9 9.64s17.29.08 37.97-3.56 37.19-7.96 36.9-9.64-17.29-.08-37.97 3.56Z"
        />
        <path
          fill="#9c0000"
          d="m559.94 562.59 14.48-2.55s1.19-.27 2.83 1.28c1.64 1.56 12.74 12.42 13.73 13.77 1 1.35 2.78 12.96 2.95 14.28.12.96 0 2.13-1.38 2.92-.03.02-.84.18-.89.2a8.013 8.013 0 0 0-9.53-6.13 8.013 8.013 0 0 0-6.2 9.18l-9.97 1.76s-6.02-34.63-6.03-34.7m2.72 12.88c.16.73.76 1.29 1.5 1.38 11.84 1.47 19.41-4.03 19.61-4.36.2-.34-.14-.76-.14-.76s-4.79-5.1-6.4-7.12c-1.61-2.02-2.87-2.01-2.87-2.01l-12.55 2.21c-.55.1-.92.63-.83 1.18s1.68 9.47 1.68 9.47Z"
        />
        <g clip-path="url(#a)">
          <path
            fill="#c9e6ed"
            d="m567.38 563.84 6.96-1.23s1.26 0 2.87 2.01c1.61 2.02 6.4 7.12 6.4 7.12s.34.42.14.76c-.19.33-7.77 5.83-19.61 4.36-.74-.09-1.35-.65-1.5-1.38l-1.68-9.47c-.1-.55.27-1.08.83-1.18l5.59-.99Z"
          />
        </g>
        <path
          fill="#87030a"
          d="M530.45 603.59a6.104 6.104 0 0 1 4.94-7.06 6.104 6.104 0 0 1 7.06 4.94c.02.13.04.25.05.38l-11.97 2.11c-.03-.12-.06-.25-.08-.38"
        />
        <path
          fill="#bf0004"
          d="M514.17 567.75s-.91-2.97 2.36-3.74c3.29-.78 12.32-3.47 38.17-7.36 0 0 4.75-.64 5.23 2.07l6.82 38.68s-.01.18-.81.32l-21.54 3.8c-.02-.13-.03-.25-.06-.38a8.008 8.008 0 0 0-9.28-6.5 8.008 8.008 0 0 0-6.5 9.28c.02.13.05.25.08.38l-6.13 1.08s-1.54.4-1.85-1.41-4.18-22.11-6.47-36.22"
        />
        <path
          fill="#3e3e3d"
          d="M576.89 595.4c.68 3.84 4.33 6.4 8.17 5.72 3.84-.68 6.4-4.33 5.72-8.17a7.046 7.046 0 0 0-8.17-5.72c-3.84.68-6.4 4.33-5.72 8.17M529.51 603.76c.68 3.84 4.33 6.4 8.17 5.72s6.4-4.33 5.72-8.17-4.33-6.4-8.17-5.72c-3.84.68-6.4 4.33-5.72 8.17"
        />
        <path
          fill="#9ab4be"
          d="M579.49 594.94a4.412 4.412 0 1 0 8.69-1.53 4.412 4.412 0 0 0-8.69 1.53M532.11 603.3a4.412 4.412 0 1 0 8.69-1.53 4.412 4.412 0 0 0-8.69 1.53"
        />
        <path
          fill="#f6f3f1"
          d="M540.95 584.69s9.96-8.65 5.02-13.13c-3.41-3.08-6.44 3.72-6.44 3.72s-1.57-4.04-5.22-3.16c-3.65.89-1.16 9.28 6.64 12.56"
        />
        <path
          fill="#ebf5f7"
          d="M573.78 576.51c.13-.02.25-.04.37-.07l-12.49-8.74.72 4.04 7.43 5.2c1.29-.05 2.58-.19 3.85-.41l.11-.02Zm9.37-3.54-13.68-9.58-7.31 1.29c-.16.03-.31.09-.44.19l15.45 10.82c2.11-.62 4.12-1.54 5.98-2.72Z"
        />
        <path fill="#7a080f" d="m560.587 562.474.443-.078 6.116 34.685-.443.078z" />
        <path
          fill="#708a9b"
          d="m575.8 459.4-89.3 16c-8.82 1.57-14.71 9.97-13.2 18.8l37.3 209.3c.81 4.43 3.34 8.11 6.77 10.48 3.43 2.37 52.55-107.43 59.63-136.44 13.71-56.13 14.22-113.12 10.79-115.47a16.273 16.273 0 0 0-12.19-2.57l.2-.1Z"
          opacity=".08"
        />
        <path
          fill="none"
          stroke="#616160"
          stroke-miterlimit="10"
          stroke-width="6"
          d="m574.9 460.1-87.3 15.6c-9.62 1.77-16 10.97-14.3 20.6L510 701.6c1.73 9.66 10.94 16.1 20.6 14.4l87.4-15.6c9.62-1.77 16-10.97 14.3-20.6l-36.7-205.3c-1.73-9.66-10.94-16.1-20.6-14.4h-.1Z"
        />
        <rect
          width="28.35"
          height="7.09"
          x="521.26"
          y="478.19"
          fill="#616160"
          rx="3.16"
          ry="3.16"
          transform="rotate(-9.87 535.484 481.792)"
        />
        <path
          fill="#e5ddd5"
          d="M894.8 372.8c-13.45-117.78-62.86-178.23-184.2-188.1-78.21-22.04-135.2-90.78-216-106.4-62.03-13.68-123.14 12.69-174.9 45.2-95.05 55.84-172.74 160.97-154.9 275.7-33.21 75.94-69.32 170.88-18.7 247 18.87 28.54 46.28 51 75.4 68.5 78.66 47.89 172.44 65.38 263.5 67.5 87.73.94 182.85-11.32 253.6-67.3 30.42-27.98 48.84-66.34 60.9-105.4 63.31-62.09 107.45-145.37 95.2-236.7h.1Zm2.8-.3c12.05 89.23-24.41 179.51-84.2 245l2.1-3.7c-10.36 46.12-29.92 93.48-65.8 125.9-101.12 80.93-252.85 84.87-375.2 61.8-110.14-22.34-254.24-84.42-270.5-209.9-7.92-68.78 22.77-134.37 50.8-195.3l-.4 2.8c-13.7-113.73 57.46-217.98 145.9-282.7 38.8-27.94 80.68-54.26 128.3-63.4 57.53-11.88 115.98 7.93 164.2 39 40.81 24.52 76.98 58.27 121.7 74.8l-1.4-.3c123.28 19.47 171.94 85.5 184.5 206Z"
        />
        <path
          fill="#fff"
          d="M0 0v850.3h997.3V0H0Zm898 438.7c-7.7 65.95-38.96 127.74-82.9 177-7.53 32.64-19.51 65.67-38.9 93.6-7.59 11.08-16.55 21.51-26.5 30.5-48.41 39.63-110.28 59.77-171.5 68.5-117.98 14.86-243.05-1.21-348.5-58-50.31-28.08-98.69-68.01-117.9-124.1-26.34-77.96 9.7-158.47 42.5-228.7-12.91-113.14 57.87-216.8 146-281.1C340.75 87.28 384.87 59.59 435 52c91.27-16.75 167.47 46.78 238.2 94.1 13.3 8.3 26.8 15.6 41 20.6 12.2 2 24.2 4.7 36.2 8 24.66 6.74 48.68 16.7 69.5 31.7 45.1 31.5 65.36 85.97 73.8 138.4 5.29 30.95 8.34 62.59 4.3 93.9Z"
        />
      </svg>
    </orderstatus-image>
    <orderstatus-detail>
      <h2>{context.textResources.headline}</h2>
      <p>{context.textResources.description}</p>
      <a
        href={context.forwardLink.replace('{{query}}', context.searchQuery)}
        data-pageidentifier={context.forwardPageidentifier}
        onClick={(e: Event) => context.moduleController.onForwardButtonClick(e.target)}
      >
        {context.textResources.buttonLabel}
      </a>
    </orderstatus-detail>
  </module>,
  // ,
  // <OnSiteSearchServiceLinks slotnamePrefix={"orderstatus-"} headline={context.textResources.serviceLinks.headline} />
];

export default OrderStatusOnSiteSearchModuleTemplate;
